import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=c3d5d354&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"
import style0 from "./favorite.vue?vue&type=style&index=0&id=c3d5d354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d5d354",
  null
  
)

export default component.exports